<template>
  <div>
    <b-row>
      <b-col sm="5">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-users'></i> Operator Group</h5>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="operatorGroup" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(action)="data">
                <b-button variant="info" @click="getPrivilegeList(data.item.Id, data.item.GroupName)"><i class="icons icon-eye"></i></b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(operatorGroup)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="7">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class="fa fa-key"></i> Privilege Function</h5>
            <b-button variant="primary" class="float-right" @click="setPrivilege">Save</b-button>
          </b-card-header>
          <b-card-body>
            <h3>{{ selectGroup.name }}</h3>
            <treeselect flat multiple v-model="selectPrivilege" isDefaultExpanded :default-expand-level="5" always-open :max-height="100000" :normalizer="normalizer"  :options="privilegeList"/>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../../events.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// const {required, minLength, maxLength} = require('vuelidate/lib/validators')
export default {
  name: 'set-operator-group-privilege',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      selectGroup: {
        id: '',
        name: ''
      },
      selectPrivilege: [],
      operatorGroup: [],
      fields: [
        {key: 'Id', label: 'Group Id'},
        {key: 'GroupName', label: 'Group Name'},
        {key: 'action', label: 'Action'}
      ],
      privilegeList: [],
      perPage: 10,
      currentPage: 1
    }
  },
  components: {
    Treeselect
  },
  methods: {
    normalizer (node) {
      return {
        id: node.Id,
        label: node.PrivilegeDisplayName,
        children: node.children
      }
    },
    getRowCount (items) {
      return items.length
    },
    async setPrivilege () {
      try {
        let data = {
          groupId: this.selectGroup.id,
          items: this.selectPrivilege
        }
        await this.$http.post(this.API_ENDPOINT + '/system/privilege/set', data, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Access Control Updated Successfully')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getOperatorGroup () {
      try {
        let { data } = await this.$http.get(this.API_ENDPOINT + '/system/privilege/group', { headers: { 'Content-Type': 'application/json' } })
        this.operatorGroup = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getPrivilegeList (groupId, groupName) {
      this.selectGroup = {
        id: groupId,
        name: groupName
      }
      let { data } = await this.$http.get(this.API_ENDPOINT + `/system/privilege/list?groupId=${groupId}`, { headers: { 'Content-Type': 'application/json' } })
      this.privilegeList = data.list.list
      console.log(this.privilegeList)
      this.selectPrivilege = data.list.allowAccess
    }
  },
  async created () {
    await this.getOperatorGroup()
    await this.getPrivilegeList(this.operatorGroup[0]['Id'], this.operatorGroup[0].GroupName)
  }
}
</script>

<style>
.vue-treeselect__menu-container {
  position: static !important;
}
.vue-treeselect__menu {
  position: static !important;
  max-height: auto !important;
}
.vue-treeselect__tip.vue-treeselect__no-children-tip {
  display: none;
}
.vue-treeselect__control {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/views/accessPrivilege/AccessPrivilegeTable.vue